import { Crud, httpClient, HttpClient } from 'lib/HttpClient';

class ClerksApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.USER_SERVICE_URL, 'terminal/access', {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }
}

export const clerksApi = new ClerksApi(httpClient);
